/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import e from"../config.js";const o=()=>e.respectPrefersReducedMotion&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;export{o as prefersReducedMotion};
